import { useState } from "react";
import { Box, Card, CardBody, Flex, Spinner, Text, useToast } from "@chakra-ui/react";
import { useAccountManager } from "applesauce-react/hooks";
import { SimpleAccount } from "applesauce-accounts/accounts";

import Fingerprint04 from "../icons/fingerprint-04";
import { isPasskeySupported, unlockAnyPasskey } from "../../services/passkey";

export default function PasskeyUnlockButton() {
  const manager = useAccountManager();
  const toast = useToast();
  const [loading, setLoading] = useState(false);

  if (!isPasskeySupported()) return null;

  const handleUnlock = async () => {
    setLoading(true);
    try {
      const { secretKey } = await unlockAnyPasskey();
      const account = SimpleAccount.fromKey(secretKey);
      manager.addAccount(account);
      manager.setActive(account);
    } catch (err) {
      const message = err instanceof Error ? err.message : "Passkey unlock failed";
      if (!message.includes("cancelled")) {
        toast({ description: message, status: "error", duration: 5000 });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      as="button"
      variant="outline"
      cursor="pointer"
      textAlign="left"
      w="full"
      onClick={handleUnlock}
      _hover={{ borderColor: "purple.400", shadow: "md" }}
      transition="all 0.15s"
      opacity={loading ? 0.7 : 1}
    >
      <CardBody p="4">
        <Flex align="center" gap="2" mb="1">
          <Box color="purple.400" flexShrink={0}>
            {loading ? <Spinner size="sm" /> : <Fingerprint04 boxSize={6} />}
          </Box>
          <Text fontWeight="bold" fontSize="md">
            {loading ? "Authenticating..." : "Passkey"}
          </Text>
        </Flex>
        <Text fontSize="sm" opacity={0.7}>
          Unlock with Face ID, Touch ID, or security key.
        </Text>
      </CardBody>
    </Card>
  );
}
